import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import { PermissionStore } from '../../stores/permission-store';
import { iiafe } from '../../utils/async';
import { FeatureFlagsManager } from '../../utils/core/feature-flags-manager';
import { useApplyLangFromUrl } from '../hooks/use-apply-lang-from-url';
import { SharedLinkHeader } from '../layout/shared-link-header';
import { SharedViewPage } from '../pages/shared-view/shared-view-page';
import { ThemeManager } from '../themes/theme-manager';

const SharedViewRoute = () => {
  const { sharedViewId } = useParams<{ sharedViewId: string }>();

  useApplyLangFromUrl();

  // Initialize theme and permissions at route level (matching SharedViewController behavior)
  React.useEffect(() => {
    ThemeManager.instance.initSettings(true);

    // Fetch the permission for shared view in the same place where the theme is initiated.
    if (FeatureFlagsManager.instance.isEnabled('SK-4477-access-management')) {
      iiafe(async () => {
        await PermissionStore.instance.refreshAccessState();
      });
    }
  }, []);

  if (!sharedViewId) {
    return null;
  }

  return (
    <Layout>
      <SharedLinkHeader />
      <ViewerContainer>
        <SharedViewPage sharedViewId={sharedViewId} />
      </ViewerContainer>
    </Layout>
  );
};

export { SharedViewRoute };

const Layout = styled.div`
  height: 100vh;
  width: 100vw;
  display: grid;
  grid-template-rows: auto 1fr;
`;

const ViewerContainer = styled.div`
  position: relative;
  min-height: 0;
  overflow: hidden;
`;
